/**
 * Gets the user's current timezone from the browser
 * @returns The IANA timezone identifier (e.g., 'America/New_York')
 */
export function getUserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.error("Error detecting timezone:", error);
    return "UTC"; // Default to UTC if detection fails
  }
}

/**
 * Gets the current timezone offset in minutes
 * @returns The timezone offset in minutes (e.g., -300 for UTC-5)
 */
export function getTimezoneOffset(): number {
  return new Date().getTimezoneOffset();
}
